import RateChartEditor from '../../features/rate-chart/RateChartEditor';
import { useRateChartSource } from '../../features/rate-chart/rateChartSource';
import { useTranslation } from '../../i18n/hooks/useTranslation';
import EditorWindow from './EditorWindow';

/**
 * The rate-chart poster editor in a full-screen window (the app's shared editor design) — use it anywhere.
 *
 *   <RateChartModal open={open} onClose={() => setOpen(false)} />                        starts from the shop's saved price list
 *   <RateChartModal open={open} onClose={…} services={list} />                           …or from a list you already have
 *   <RateChartModal open={open} onClose={…} shop={{ name, phone, address, qrUrl, logoUrl }} />   overrides the shop-profile details
 *
 * `services` is [{ name, price, category? }] — `category` is only for the built-in modules. Nothing is saved or sent anywhere;
 * the editor starts fresh every time it opens. For a ready-made trigger button see <RateChartButton>.
 */
export default function RateChartModal({ open, onClose, services, shop }) {
    const { t } = useTranslation();
    const source = useRateChartSource({ services, shop, enabled: open });

    return (
        <EditorWindow open={open} onClose={onClose} title={t('rateChart.top.title')}>
            <RateChartEditor services={source.services} shop={source.shop} onClose={() => onClose?.()} />
        </EditorWindow>
    );
}
